import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import Cel from './DatagridCell';
import { numberFormat, colorFix, formatVolume10 } from '../../utils';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  makeGetAuth,
  makeGetSymbolState,
  makeGetToken,
} from '../../lib/selector';
import {
  setAuth,
  setDblPrice,
  setLogin,
} from '../../containers/client/actions';

import { isMobile } from 'react-device-detect';

function DatagridRowGroup(props) {
  const dispatch = useDispatch();

  const [cl, setCl] = useState(null);
  const [clHigh, setClHigh] = useState(null);
  const [clLow, setClLow] = useState(null);
  const [clAve, setClAve] = useState(null);

  const { auth, token, isPc, record, symbol } = props;

  useEffect(() => {
    const _cl = colorFix(
      record.lastPrice,
      record.r,
      record.c,
      record.f,
      record.r
    );
    const _clHigh = colorFix(
      record.highPrice,
      record.r,
      record.c,
      record.f,
      record.r
    );
    const _clLow = colorFix(
      record.lowPrice,
      record.r,
      record.c,
      record.f,
      record.r
    );
    const _clAve = colorFix(
      record.avePrice,
      record.r,
      record.c,
      record.f,
      record.r
    );
    setCl(_cl);
    setClHigh(_clHigh);
    setClLow(_clLow);
    setClAve(_clAve);
  }, [record]);

  const _handleTradeSym = (sym = '', side = 'BUY', price = '') => {
    if (!token) {
      dispatch(setLogin());
      return false;
    }

    if (!auth || !auth.isVerified) {
      dispatch(setAuth());
      return false;
    }

    const newOrder = {
      symbol: sym,
      side: side,
      price: '',
    };
    console.log('Trade Symbol', newOrder);
    dispatch(setDblPrice(newOrder));
  };

  return (
    <tr id={record.sym + 'row'}>
      <td className={'text-left ' + cl} id={record.sym + 'sym'}>
        {isMobile ? (
          <a onClick={() => props.handleOpenModal(record.sym)}>{record.sym}</a>
        ) : (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-top`}>{symbol && symbol.name_vn}</Tooltip>
            }
          >
            <a onClick={() => props.handleOpenModal(record.sym)}>
              {record.sym}
            </a>
          </OverlayTrigger>
        )}
      </td>
      <td className="text-right high-light c" id={record.sym + 'ceil'}>
        {numberFormat(record.c, 2)}
      </td>
      <td className="text-right high-light f" id={record.sym + 'floor'}>
        {numberFormat(record.f, 2)}
      </td>
      <td className="text-right high-light r" id={record.sym + 'ref'}>
        {numberFormat(record.r, 2)}
      </td>
      <Cel
        data={{ bP3: record.bP3, bVC3: record.bCl3 }}
        sym={record.sym}
        type="bP3"
        className="text-right"
        doubleClick={_handleTradeSym}
      ></Cel>
      <Cel
        data={{ bV3: record.bV3, bVC3: record.bVC3, bCl3: record.bCl3 }}
        sym={record.sym}
        type="bV3"
        className="text-right"
      ></Cel>
      <Cel
        data={{ bP2: record.bP2, bVC2: record.bCl2 }}
        sym={record.sym}
        type="bP2"
        className="text-right"
        doubleClick={_handleTradeSym}
      ></Cel>
      <Cel
        data={{ bV2: record.bV2, bVC2: record.bVC2, bCl2: record.bCl2 }}
        sym={record.sym}
        type="bV2"
        className="text-right"
      ></Cel>
      <Cel
        data={{ bP1: record.bP1, bVC1: record.bCl1 }}
        sym={record.sym}
        type="bP1"
        className="text-right"
        doubleClick={_handleTradeSym}
      ></Cel>
      <Cel
        data={{ bV1: record.bV1, bVC1: record.bVC1, bCl1: record.bCl1 }}
        sym={record.sym}
        type="bV1"
        className="text-right"
      ></Cel>
      <Cel
        data={{
          lastPrice: record.lastPrice,
          r: record.r,
          c: record.c,
          f: record.f,
          cl: record.cl,
        }}
        sym={record.sym}
        type="lastPrice"
        className="text-right high-light"
        doubleClick={_handleTradeSym}
      ></Cel>
      <Cel
        data={{
          lastVolume: record.lastVolume,
          lastPrice: record.lastPrice,
          r: record.r,
          c: record.c,
          f: record.f,
          cl: record.cl,
        }}
        sym={record.sym}
        type="lastVolume"
        className="text-right high-light"
      ></Cel>
      {/* <td
        id={record.sym + (isPc ? 'changePc' : 'change')}
        className={'text-right high-light ' + (record.cl || cl)}
      >
        {record.lastPrice == 0
          ? ''
          : isPc
          ? numberFormat(record.changePc, 2)
          : numberFormat(record.change, 2)}
      </td> */}
      <td
        // id={record.sym + (isPc ? 'changePc' : 'change')}
        className={'text-right high-light ' + (record.cl || cl)}
      >
        <span
          id={record.sym + 'change'}
          style={{ display: isPc ? 'none' : '' }}
        >
          {record.lastPrice == 0 ? '' : numberFormat(record.change, 2)}
        </span>
        <span
          id={record.sym + 'changePc'}
          style={{ display: isPc ? '' : 'none' }}
        >
          {record.lastPrice == 0 ? '' : numberFormat(record.changePc, 2) + '%'}
        </span>
      </td>
      <Cel
        data={{ oP1: record.oP1, oVC1: record.oCl1 }}
        sym={record.sym}
        type="oP1"
        className="text-right"
        doubleClick={_handleTradeSym}
      ></Cel>
      <Cel
        data={{ oV1: record.oV1, oVC1: record.oVC1, oCl1: record.oCl1 }}
        sym={record.sym}
        type="oV1"
        className="text-right"
      ></Cel>
      <Cel
        data={{ oP2: record.oP2, oVC2: record.oCl2 }}
        sym={record.sym}
        type="oP2"
        className="text-right"
        doubleClick={_handleTradeSym}
      ></Cel>
      <Cel
        data={{ oV2: record.oV2, oVC2: record.oVC2, oCl2: record.oCl2 }}
        sym={record.sym}
        type="oV2"
        className="text-right"
      ></Cel>
      <Cel
        data={{ oP3: record.oP3, oVC3: record.oCl3 }}
        sym={record.sym}
        type="oP3"
        className="text-right"
        doubleClick={_handleTradeSym}
      ></Cel>
      <Cel
        data={{ oV3: record.oV3, oVC3: record.oVC3, oCl3: record.oCl3 }}
        sym={record.sym}
        type="oV3"
        className="text-right"
      ></Cel>
      <td className="text-right lot" id={record.sym + 'lot'}>
        {formatVolume10(record.lot)}
      </td>
      <td
        className={'text-right high-light ' + clHigh}
        id={record.sym + 'highP'}
      >
        {numberFormat(record.highPrice, 2)}
      </td>
      <td className={'text-right high-light ' + clLow} id={record.sym + 'lowP'}>
        {numberFormat(record.lowPrice, 2)}
      </td>
      <td className={'text-right high-light ' + clAve} id={record.sym + 'aveP'}>
        {numberFormat(record.avePrice, 2)}
      </td>
      <td colSpan="2" className="position-relative">
        <span className="slidable">
          <div
            className="cell-1-2 text-right"
            id={record.sym + 'fBVol'}
            style={{ display: props.isRoom ? '' : 'none' }}
          >
            {formatVolume10(record.fBVol)}
          </div>
          <div
            className="cell-1-2 text-right"
            id={record.sym + 'fSVol'}
            style={{ display: props.isRoom ? '' : 'none' }}
          >
            {formatVolume10(record.fSVolume)}
          </div>
          <div
            className="cell-1-1 text-right"
            id={record.sym + 'fRoom'}
            style={{ display: props.isRoom ? 'none' : '' }}
          >
            {formatVolume10(record.fRoom)}
          </div>
        </span>
      </td>
      <td className="text-right lot" id={record.sym + 'duMua'}>
        {formatVolume10(record.duMua)}
      </td>
      <td className="text-right lot" id={record.sym + 'duBan'}>
        {formatVolume10(record.duBan)}
      </td>
      {/* <td className="text-right lot" id={record.sym + 'fBVol'}>
        {formatVolume10(record.fBVol)}
      </td>
      <td className="text-right lot" id={record.sym + 'fSVol'}>
        {formatVolume10(record.fSVolume)}
      </td> */}
    </tr>
  );
}

const makeMapStateToProps = () => {
  const getSymbolState = makeGetSymbolState();
  const getAuth = makeGetAuth();
  const getToken = makeGetToken();
  const mapStateToProps = (state, props) => {
    return {
      symbol: getSymbolState(state, props),
      auth: getAuth(state),
      token: getToken(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(DatagridRowGroup);
